import _ from "lodash";
import React from "react";
import { GetAllActiveItemProperties, GetActiveitemCategory } from "../../../axios";
import { Button, FormCheckBox, FormDropDown } from "../../../components";
import LoaderComponent from "../../../components/common/Loader";
import { colors } from "../../../configs";
import Strings from "../../../translations";

const CreateMappingCategoryPropertyForm = ({
  errorMessage,
  setMessage,
  handleResultData,
  actionType,
  initialValue = {},
  handleModalClose,
}) => {
  const [loading, setLoading] = React.useState(false);
  const [initialItemCategory, setInitialItemCategory] = React.useState([]);
  const [itemCategory, setItemCategory] = React.useState([]);
  const [selectData, setSelectData] = React.useState({ value: "", error: false, success: true });
  const [options, setOptions] = React.useState([]);
  const [searchTerm, setSearchTerm] = React.useState("");

  React.useEffect(() => {
    setInitialItemCategory(
      initialValue.properties?.map((p) => ({ key: p.id, name: p.name, checked: true })) || []
    );

    setSelectData({
      value: initialValue.id || "",
      error: false,
      success: actionType === "edit" ? true : false,
    });

    setLoading(true);
    const propertyIds = initialValue.properties?.map((p) => p.name) || [];

    GetAllActiveItemProperties()
      .then((res) => {
        setItemCategory(
          res.data.data.map((elm) => ({
            key: elm.id,
            name: elm.name,
            checked: propertyIds.includes(elm.name),
          }))
        );
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [initialValue, actionType]);


  const getAllActiveItemCategory = () => {
    setLoading(true);
    GetActiveitemCategory()
      .then((res) => {
        setOptions(
          res.data.data.map((elm) => ({ key: elm.id, value: elm.id, label: elm.name }))
        );
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  React.useEffect(() => getAllActiveItemCategory(), []);

  const handleChangeCheck = (key) => {
    setItemCategory(
      itemCategory.map((item) =>
        item.key === key ? { ...item, checked: !item.checked } : item
      )
    );
  };

  const handleSelectDropDown = (value) => {
    setMessage(null);
    setSelectData(value);
  };

  const getSelectedPropertyIds = () =>
    itemCategory.filter((i) => i.checked).map((i) => i.key);

  const handleSaveData = () => {
    const formData = {
      item_category_id: selectData.value,
      item_property_ids: getSelectedPropertyIds(),
    };
    handleResultData(formData);
  };

  const disableAdd =
    selectData.value === "" ||
    selectData.error ||
    selectData.success === false ||
    itemCategory.every((item) => !item.checked);

  const disableEdit =
    _.isEqual(
      itemCategory.map((i) => ({ key: i.key, checked: i.checked })),
      initialItemCategory.map((i) => ({ key: i.key, checked: i.checked }))
    ) && selectData.value === (initialValue.id || "");

  const pageHeader = Strings["ItemCategoryPropertyMapping.CreateMapping"];
  const editPageHeader = Strings["ItemCategoryPropertyMapping.EditMapping"];
  const dropdownLabel = Strings["ItemCategoryPropertyMapping.SelectItemCategory"];
  const dropdownCustomError =
    Strings["VendorCompanytoCategoryMapping.CategoryCustomError"];
  const selectText = Strings["ItemCategoryPropertyMapping.SelectItemCategory"];
  const selctRoleHeader = Strings["ItemCategoryPropertyMapping.SelectItemProperty"];
  const SaveButton = Strings["VendorCompanytoCategoryMapping.SaveBtn"];
  const cancelButton = Strings["VendorCompanytoCategoryMapping.CancelBtn"];

  const filteredItemGroups = React.useMemo(() => {
    if (!itemCategory || !Array.isArray(itemCategory)) return [];
    return itemCategory.filter((item) =>
      item.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [itemCategory, searchTerm]);

  return (
    <div className="modalFormContainer">
      {loading && <LoaderComponent />}
      <h2>{actionType === "add" ? pageHeader : editPageHeader}</h2>
      {errorMessage && <h6 style={{ color: "red" }}>{errorMessage}</h6>}

      <FormDropDown
        labelStyle={{ marginTop: "10px", marginBottom: "10px" }}
        selectText={selectText}
        Label={dropdownLabel}
        Options={options}
        onSelect={handleSelectDropDown}
        customErrorLine={dropdownCustomError}
        searchable={false}
        value={selectData.value}
        disable={actionType === "edit"}
        isValidate={true}
      />

      <br />
      <h4>{selctRoleHeader}</h4>
      <div style={{ marginBottom: "15px" }}>
        <input
          type="text"
          placeholder="Search item property..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            padding: "8px",
            width: "100%",
            border: "1px solid #ddd",
            borderRadius: "10px",
            fontSize: "14px",
            marginBottom: "20px",
            outline: "none",
          }}
        />
      </div>

      <div className="row">
        {filteredItemGroups.map((item) => (
          <div className="col-12 col-md-4" key={item.key}>
            <FormCheckBox
              Label={item.name}
              checked={item.checked}
              handleChangeCheck={() => handleChangeCheck(item.key)}
            />
          </div>
        ))}
      </div>

      <div className="row deleteFunction__buttongroup">
        <div style={{ display: "flex", marginTop: "30px" }}>
          <Button
            buttonName={SaveButton}
            disable={actionType === "add" ? disableAdd : disableEdit}
            onClick={handleSaveData}
            buttonStyle={{ backgroundColor: colors.primary }}
          />
          <Button
            buttonName={cancelButton}
            onClick={() => {
              handleModalClose();
              setMessage(null);
            }}
            buttonStyle={{ backgroundColor: colors.darkgrey, marginLeft: "10px" }}
          />
        </div>
      </div>
    </div>
  );
};

export default CreateMappingCategoryPropertyForm;
